const data = [
    { id: 1, name: "Quórum simples" },
    { id: 2, name: "Quórum qualificado" },
    
];
  
export default [...data];